import React, { Component } from "react";
import { numberWithCommas } from "../../../../helpers/dataHelpers";

import { Table, Button, Navbar, Nav } from "react-bootstrap";
import ActiveViewFilter from "../../view_filters/Sales/ActiveViewFilter";
import { openModal } from "../../../../store/actions/ModalActions";

import moment from "moment";
import ModuleLocked from "../../../../components/extensions/ModuleLockedView";
import { moduleNames } from "../../../../helpers/dashboardModuleNames";
import { DashboardContext } from "../../dashboard_context";

const customTextStyle = { textAlign: "center" };

class ActivePawn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
    };
  }

  renderTableRows = (data) => {
    return (
      <React.Fragment>
          <p style={{ color: "#F4511E", whiteSpace:'nowrap'}}>
          {moment(data.key.covered_date).format("MMMM DD YYYY")}
          </p>
        <tr>
          <td className="text-center">
            <React.Fragment>
              <h4 style={customTextStyle}>
                {numberWithCommas(data.value.totalPieces)}
              </h4>
            </React.Fragment>
          </td>
          <td className="text-center">
            <React.Fragment>
              <h4 style={customTextStyle} className="text-monospace mr-1">
                {`₱${numberWithCommas(data.value.totalPrincipal)}`}
              </h4>
            </React.Fragment>
          </td>
        </tr>
      </React.Fragment>
    );
  };

  render() {
    return (
      <div>
        <Navbar>
          <Navbar.Brand
            className="h5"
            style={{ color: this.context.titleColor }}
          >
            <div className="d-inline">{this.props.listTitle}</div>
          </Navbar.Brand>
          <Navbar.Text>
            <p className="small">{this.props.subTitle}</p>
          </Navbar.Text>
          <Navbar.Collapse className="align-content-between">
            <Nav className="mr-auto" />
            <Nav>
              <Button
                variant="outline-secondary"
                className="m-1"
                size="sm"
                onClick={() => {
                  openModal({
                    title: "View Active Pawns",
                    size: "lg",
                    custom: false,
                    currentComponent: <ActiveViewFilter />,
                  });
                }}
              >
                Filter
              </Button>
              <ModuleLocked
                Lock={() => this.context.Lock(moduleNames.salesActive)}
                Unlock={() => this.context.Unlock(moduleNames.salesActive)}
                isLocked={this.context.salesActiveLocked}
              />
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Table borderless size="sm">
          <tbody>
            {this.props.list.map((data) => {
              return this.renderTableRows(data);
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

ActivePawn.contextType = DashboardContext;

export default ActivePawn;
